export class MoleculePanelOverviewHeaderMultiDeleteWebhostingActionComponent {
    public templateUrl = require('./multi-delete-webhosting-action.html?external');
}
